import partnersDomainReducer from './domain'

export const domain = partnersDomainReducer
export const entities = {}
